import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ArrowLeft, ScrollText } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from '../components/LanguageSwitcher';

const PageHeader = ({ privacyLabel, eulaLabel }) => (
  <header className="fixed top-0 w-full bg-white z-50 border-b border-gray-200">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-4 flex items-center justify-between gap-6">
      <Link to="/" className="flex items-center flex-shrink-0">
        <img
          src="https://imgur.com/nYWIvWJ.png"
          alt="Nextcoders Logo"
          className="h-8"
          onError={(e) => {
            e.target.onerror = null;
            e.target.src = 'https://placehold.co/150x32/1f2937/ffffff?text=Nextcoders';
          }}
        />
      </Link>
      <div className="flex items-center gap-4">
        <LanguageSwitcher variant="compact" />
        <Link to="/posti" className="text-gray-600 hover:text-[#141414] font-medium text-sm transition">
          Posti
        </Link>
        <Link to="/posti-privacidad" className="text-gray-600 hover:text-[#141414] font-medium text-sm transition">
          {privacyLabel}
        </Link>
        <Link to="/posti-eula" className="text-gray-600 hover:text-[#141414] font-medium text-sm transition">
          {eulaLabel}
        </Link>
      </div>
    </div>
  </header>
);

const PostiTerminosPage = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const dateLocale = i18n.resolvedLanguage === 'en' ? 'en-US' : i18n.resolvedLanguage === 'pt' ? 'pt-BR' : 'es-ES';
  const sections = t('posti_legal.terms_sections', { returnObjects: true });

  return (
    <div className="min-h-screen bg-[#faf9f6] font-inter">
      <PageHeader privacyLabel={t('posti_legal.privacy_link')} eulaLabel={t('posti_legal.eula_link')} />

      <main className="pt-32 pb-24 px-4 sm:px-6">
        <div className="max-w-4xl mx-auto">
          <button
            type="button"
            onClick={() => (window.history.length > 1 ? navigate(-1) : navigate('/posti'))}
            className="inline-flex items-center gap-2 text-gray-500 hover:text-[#141414] mb-8 transition font-medium"
          >
            <ArrowLeft size={16} />
            {t('posti_legal.back_to_posti')}
          </button>

          <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-gray-100">
            <div className="flex items-center gap-4 mb-8">
              <div className="p-3 bg-emerald-100 text-emerald-700 rounded-xl">
                <ScrollText size={28} />
              </div>
              <h1 className="text-3xl md:text-4xl font-bold text-[#2d2a26]">
                {t('posti_legal.terms_title')}
              </h1>
            </div>

            <div className="prose prose-emerald max-w-none text-gray-600 leading-relaxed">
              <p>{t('posti_legal.last_update')}: {new Date().toLocaleDateString(dateLocale)}</p>
              {Array.isArray(sections) && sections.map((section, idx) => (
                <div key={section.title || idx}>
                  <h3 className="text-xl font-bold text-[#2d2a26] mt-8 mb-4">{section.title}</h3>
                  <p>{section.body}</p>
                </div>
              ))}
            </div>
            
            <div className="mt-12 pt-8 border-t border-gray-100 flex gap-4">
              <Link to="/posti" className="px-6 py-3 bg-emerald-600 text-white rounded-xl font-semibold hover:bg-emerald-700 transition">
                {t('posti_legal.accept_and_back')}
              </Link>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PostiTerminosPage;
